import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/31.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Do widzenia!"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p58,
            }}
            content={
                <div>
                    <ul>
                        <li>
                        Do widzenia! Niedługo znów się spotkamy – żegna cię starzec.
                        </li>
                    </ul>
                    <p>
                    „Skąd ta pewność?” – myślisz. Zza chmur wychodzi księżyc i białe włosy Tornaua pokrywają się niebieską poświatą.
                    </p>
                    <ul>
                        <li>
                        Pozdrów Emila, szerokiej drogi do Tarszewa! – mruga porozumiewawczo i znika w trzcinie przy brzegu. Wracasz do Emila, który wygląda, jakby zaimponowała mu twoja eskapada. Do Tarszewa dojeżdżacie w milczeniu.
                        </li>
                    </ul>
                </div>
            }
        />

    );
}